export default __webpack_public_path__ + "static/media/poll_2.3ea7c92b.jpg";